import axios from "axios";

//poziv express-u da dohvati podatke vezane uz osobu
export default {
  getUsers() {
    try {
      return axios.get("https://app-psod.cratis.cloud/api/admin/users");
    } catch (err) {
      console.log(err);
    }
  },
  changeUserRole(user_id, new_role, token) {
    try {
      return axios.post("https://app-psod.cratis.cloud/api/admin/users/" + user_id, {
        params: {
          token: token,
          new_role
        }
      });
    } catch (err) {
      console.log(err);
    }
  },
  // getUsers(token, idGrupe) {
  //   try {
  //     return axios.get("https://app-psod.cratis.cloud/api/admin/users",
  //       {
  //         params: {
  //           token: token,
  //         }
  //       });
  //   } catch (err) {
  //     console.log(err);
  //   }
  // },
}

